import React from 'react';
import { Image, ToggleButton } from 'react-bootstrap';
import classNames from 'classnames';
import { useField } from 'formik';
import { getPaymentMethod, PaymentMethods } from '@models/PaymentMethod';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

type Props = {
  value: PaymentMethods;
};

const PaymentMethodToggleControl = ({ value }: Props) => {
  const name = 'paymentMethod';
  const [field] = useField(name);
  const checked = field.value === value;
  const { image, title, description } = getPaymentMethod(value);

  return (
    <ToggleButton
      {...field}
      id={`${name}-${value}`}
      type="radio"
      className={classNames('w-100', { 'border-primary': checked })}
      variant="light"
      value={value}
      checked={checked}
    >
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <Image src={image} width={54} className="rounded" />
          <div className="d-flex flex-column align-items-start mx-3">
            <span className="fw-bold">{title}</span>
            <small className="text-secondary text-start">{description}</small>
          </div>
        </div>
        <span className="bg-secondary bg-opacity-25 rounded-circle px-2 py-1">
          <FontAwesomeIcon icon={faArrowRight} />
        </span>
      </div>
    </ToggleButton>
  );
};

export { PaymentMethodToggleControl };
